import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../../../Common/constants";
import fileDownload from 'js-file-download';

class CogList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Cogs: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { id: "NA" }
    };
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "", dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse", dataClass: "" });
    }
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/cog?platform=FK"
      )
      .then(response => {
        this.setState({ Cogs: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Flipkart - COG</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
              >
                Add COG
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit COG
              </button>
              &nbsp;&nbsp;
              <button
                onClick={this.onExportClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Export
              </button>
            </div>
            <AgGridReact
              rowData={this.state.Cogs}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="id" hide="true" />
              <AgGridColumn
                field="sku"
                headerName="SKU"
                width={150}
                checkboxSelection
                filter
                resizable
                sortable
              />
              <AgGridColumn
                field="masterSku"
                headerName="Master SKU"
                width={150}
                filter
                resizable
                sortable
              />
              <AgGridColumn
                field="stockist"
                headerName="Stockist"
                width={150}
                filter
                resizable
                sortable
              />
              <AgGridColumn
                field="cog"
                headerName="COG"
                width={50}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="gst"
                headerName="GST"
                width={50}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="transportationCost"
                headerName="Transportation Cost"
                width={110}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="stockistMarkup"
                headerName="Stockist Markup"
                width={110}
                sortable
                resizable
                filter
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  onAddClick = e => {
    this.props.onClick("", this.state.dummy);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("AddEdit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Cog !!"
      });
    }
  };

  onExportClick = e => {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/cog/export?platform=FK"
      )
      .then((res) => {
        fileDownload(res.data.Content, res.data.FileName)
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}


export default CogList;
